<template>
  <section class="section section-spacing pt-5">
    <h1 class="title mb-0 has-text-left">Income Distribution Details</h1>
    <div class="p-3">
      <!-- Search header -->
      <div class="
        columns
        rd-columns-fix
        is-multiline
        rd-bg-white
        pt-3
        pl-0
        pr-0 
        mr-0
        pb-6
        rd-br-md rd-height-fc
      ">
        
        <div class="column rd-height-fc pl-0">
          <div class="field is-expanded">
            <label class="label is-size-6 has-text-weight-normal mb-1 search-label">
              Fund Name
            </label>
            <div class="control is-expanded is-clearfix">
              <input type="text" v-model="inputFundName" placeholder="Enter fund name" autocomplete="on" class="input">
            </div>
          </div>
        </div> 

        <div class="column rd-height-fc">
          <div class="field">
            <label class="label is-size-6 has-text-weight-normal mb-1 search-label">
              Currency
            </label>
            <div class="control is-expanded">
              <span class="select is-fullwidth">
                <select v-model="inputCurrency">
                  <option value="Please select one">
                    Please select one
                  </option>
                  <option :value="currency" v-for="currency, index in removeDuplicates(currencyList)" :key="index">
                    {{currency}}
                  </option>
                </select>
              </span>
            </div>
          </div>
        </div> 
        
        <div class="column rd-height-fc">
          <div class="field">
            <label class="label is-size-6 has-text-weight-normal mb-1 search-label">
              Month
            </label>
            <div class="control is-expanded">
              <b-datepicker
                type="month"
                placeholder="Latest"
                trap-focus
                v-model="inputMonth">
              </b-datepicker>
            </div>
          </div>
        </div>

        <div class="column is-narrow rd-height-fc is-one-fifth-tablet is-one-fifth-desktop pr-0">
          <div class="field">
            <div class="control is-expanded">
              <b-button @click="searchFund()" rounded icon-right="play-outline" class="search-btn mt-2">
                SEARCH FUND
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <b-table :data="incomes" 
               :columns="columns" 
               :sticky-header="true" 
               :mobile-cards="true"
               :height="400"
               bordered
               :loading="loading"
               class="has-text-left">
      </b-table>
    </div>
  </section>
</template>

<script>
import * as dayjs from 'dayjs'

export default {
  data() {
    return {
      paramName: '',
      paramCurrency: '',
      paramFromDate: '',
      paramToDate: '',
      inputFundName: '',
      inputCurrency: 'Please select one',
      inputMonth: null,
      currencyList: [],
      incomes: [],
      loading: true,
      columns: [
          {
              field: 'FundName',
              label: 'FUND NAME',
              width: '350'
          },
          {
              field: 'Currency',
              label: 'CURRENCY',
              centered: true
          },
          {
              field: 'DeclareDate',
              label: 'EX-DATE',
              centered: true,
              width: '130'
          },
          {
              field: 'ReinvestmentDate',
              label: 'REINVESTMENT DATE',
              centered: true
          },
          {
              field: 'PaymentDate',
              label: 'PAYMENT DATE',
              centered: true,
              width: '130'
          },
          {
              field: 'Dist',
              label: 'DISTRIBUTION (SEN/CENTS PER UNIT)',
              centered: true,
              width: '180'
          },
          {
              field: 'YIELD',
              label: 'YIELD %',
              centered: true,
              width: '110'
          }
      ]
    }
  },
  mounted() {
    this.fetchIncomes('/public/fund/incomedistributiondetail');
  },
  methods: {
    fetchIncomes(URL) {
      this.loading = true;
      this.$httpClient({
        method: "GET",
        url: URL
      })
      .then((res) => {
        this.loading = false;
        let response = res.data.incomedistributiondetailResult;
        response.forEach((income) => {
          this.currencyList.push(income.Currency);
          income.DeclareDate = dayjs(income.DeclareDate).format('DD MMM YYYY');
          income.ReinvestmentDate = dayjs(income.ReinvestmentDate).format('DD MMM YYYY');
          income.PaymentDate = dayjs(income.PaymentDate).format('DD MMM YYYY');
          if(income.DeclareDate === "Invalid Date"){
            income.DeclareDate = "N/A";
          }
          if(income.ReinvestmentDate === "Invalid Date"){
            income.ReinvestmentDate = "N/A";
          }
          if(income.PaymentDate === "Invalid Date"){
            income.PaymentDate = "N/A";
          }
        })
        this.$set(this, "incomes", response);
      })
      .catch((error) => {
        this.$router.push('maintenance');
      });
    }, 
    removeDuplicates(arr){
      return arr.filter((item,index) => arr.indexOf(item) === index);
    },
    searchFund(){
      if(this.inputFundName !== null && this.inputFundName !== ''){
        this.paramName = 'pFundName=' + this.inputFundName;
      }
      if(this.inputCurrency !== null && this.inputCurrency !== 'Please select one'){
        this.paramCurrency = '&pCurrency=' + this.inputCurrency;
      }
      if(this.inputMonth !== null){
        this.paramFromDate = '&pFromDate=' + dayjs(this.inputMonth).format('YYYY-MM-DD');
        let lastDate = new Date(this.inputMonth.getFullYear(), this.inputMonth.getMonth() + 1, 0);
        this.paramToDate = '&pAsOfDate=' + dayjs(lastDate).format('YYYY-MM-DD');
      }
      this.fetchIncomes('public/fund/incomedistributiondetail?' + this.paramName + this.paramCurrency + this.paramFromDate + this.paramToDate);
      this.paramName = '';
      this.paramCurrency = '';
    }
  }
}
</script>

<style scoped lang="scss">
  .section-spacing{
    padding-left: 110px !important;
    padding-right: 100px !important;
  }

:deep(){
  .title{
    color: #323337;
    font-size: 34px; 
    font-weight: 700;
  }

  .search-label{
    text-align: left;
    font-weight: bold !important;
    text-transform: uppercase;
    color: rgba(53,93,196,1);
    font-size: 14px;
  }

  .is-relative{
    font-weight: bold !important;
    text-transform: uppercase;
    color: rgba(53,93,196,1);
    font-size: 14px;
  }

  .table.is-bordered td, .table.is-bordered th {
    padding-left: 15px;
    padding-right: 15px;
  }

  .search-btn{
    background-color: rgba(255,102,102,1);
    color: white !important;
    width: -webkit-fill-available;
    border-color: rgba(255,102,102,1) !important;
    height: 60px;
  }

  .search-btn:hover{
    background-color: white;
    color: rgba(255,102,102,1) !important;
    border-color: rgba(255,102,102,1) !important;
  }

  ::placeholder {
    color: #323337 !important;
    font-size: 0.93rem;
  }

  .datepicker .dropdown .input[readonly], .datepicker .dropdown-trigger .input[readonly]{
    cursor: text;
  }
}

@media screen and (max-width:1290px) and (min-width: 1022px){
  .section-spacing{
    padding-left: 55px !important;
    padding-right: 45px !important;
  }
}

@media screen and (max-width: 1023px) {
  .section-spacing{
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .column{
    padding-left: 0px;
  }
}

@media screen and (max-width: 768px) {
  .rd-height-fc{
    padding-right: 0px;
  }
}

@media screen and (max-width: 425px) {
  .section-spacing{
    padding-left: 15px !important;
    padding-right: 10px !important;
  }

  .title{
    font-size: 30px; 
    padding-left: 15px !important;
  }
}

</style>
